import 'react-loading-skeleton/dist/skeleton.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../styles/index.scss'
import '../styles/themes-tokens.css';
import '@mentalgrowth/ui-kit-web/dist/cjs/styles.css';

import { ResizeObserver } from '@juggle/resize-observer'
import type { DehydratedState } from "@tanstack/react-query";
import type { AppProps } from 'next/app'
import {Inter, Merriweather,Open_Sans } from 'next/font/google';
import Head from 'next/head';
import * as yup from 'yup';

import { Providers } from '@/providers';


const inter = Inter({
  weight: ['400', '600', '700', '800'],
  style: ['normal', 'italic'],
  subsets: ['latin'],
  display: 'swap',
  variable: "--font-inter",
});

const merriweather = Merriweather({
  weight: ['400', '700'],
  style: ['normal'],
  subsets: ['latin'],
  display: 'swap',
  variable: "--font-merriweather",
});

const openSans = Open_Sans({
    weight: ['400', '600', '700', '800'],
    style: ['normal', 'italic'],
    subsets: ['latin'],
    display: 'swap',
    variable: "--font-inter",
});

// Customize yup error formatting
const formatError = yup.ValidationError.formatError
yup.ValidationError.formatError = function (message, parameters) {
  if (!parameters.label) {
    parameters.label = (parameters.path + '')
      .replaceAll(
        /([a-z])([A-Z])/g,
        (_, match1, match2) => `${match1} ${match2.toLowerCase()}`
      )
      .replace(/^[a-z]/, (match) => match.toUpperCase())
  }
  return formatError.call(this, message, parameters)
}

// Polyfill ResizeObserver
if (typeof window !== 'undefined' && !window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver
}

function MyApp({ Component, pageProps }: AppProps & {
    pageProps: {
      dehydratedState: DehydratedState
    }
  }) {
    const { dehydratedState } = pageProps;
  return (
    <>
      <Head>
        <title>Youth</title>
        <meta charSet="utf8"/>
        <meta name="viewport" content="initial-scale=1.0, width=device-width"/>
      </Head>
      <style jsx global>{`html {--font-inter: ${inter.style.fontFamily};--font-merriweather: ${merriweather.style.fontFamily};--font-open-sans:${openSans.style.fontFamily};--font-family-base: var(--font-inter);--font-family-secondary: var(--font-merriweather);--font-family-tretiary:var(--font-open-sans)}`}</style>
      <Providers dehydratedState={dehydratedState}>
        <Component {...pageProps} />
      </Providers>
    </>
  )
}

export default MyApp
